type SkillOfferCardProps = {
  skillTitle: string
  active: boolean
  onAccurate: () => void
  onQuick: () => void
}

/** UI copy for the post–skill-pick offer. Does not promise clarifying questions. */
export const skillOfferMessage = (skillTitle: string) =>
  `I can build a much sharper ${skillTitle.toLowerCase()} — tuned to your business. Or I can give you a quick take right now.`

export const SkillOfferCard = ({
  skillTitle,
  active,
  onAccurate,
  onQuick,
}: SkillOfferCardProps) => (
  <div>
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        background: 'rgba(201,168,76,0.1)',
        border: '1px solid rgba(201,168,76,0.25)',
        borderRadius: 100,
        padding: '2px 9px',
        fontSize: 9.5,
        fontWeight: 600,
        color: '#C9A84C',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        marginBottom: 9,
      }}
    >
      ⚡ {skillTitle}
    </div>
    <p style={{ fontSize: 13, lineHeight: 1.75, marginBottom: active ? 12 : 0, color: 'var(--text)' }}>
      {skillOfferMessage(skillTitle)}
    </p>
    {active && (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        <button
          type="button"
          onClick={onAccurate}
          style={{
            background: 'var(--navy)',
            color: 'var(--white)',
            border: 'none',
            borderRadius: 9,
            padding: '9px 15px',
            fontSize: 12.5,
            fontWeight: 500,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(27,42,74,.18)',
          }}
        >
          Get accurate answers
        </button>
        <button
          type="button"
          onClick={onQuick}
          style={{
            background: 'transparent',
            color: 'var(--muted)',
            border: '1px solid var(--bd)',
            borderRadius: 9,
            padding: '9px 15px',
            fontSize: 12.5,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Just a quick take
        </button>
      </div>
    )}
  </div>
)
